/* istanbul ignore file */
import { array as codecArray, number as codecNumber, oneOf as codecOneOf } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { BaseDirectory } from './BaseDirectory';
import { BaseFile } from './BaseFile';
const PlagiarismMatchParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    [
        'files',
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ parsers.taggedUnion('type', [
            ['file', BaseFile],
            ['directory', BaseDirectory],
        ])),
    ],
    [
        'lines',
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ codecArray(/* #__PURE__ */ codecOneOf([codecNumber, codecNumber]))),
    ],
]);
export class PlagiarismMatch extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PlagiarismMatchParser.decode(input).map(res => new PlagiarismMatch(res));
    }
    static unsafeDecode(input) {
        return PlagiarismMatch.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PlagiarismMatchParser.encode(data);
    }
    static schema() {
        return PlagiarismMatchParser.schema();
    }
}
